































import Vue from "vue";
export default Vue.extend({
  name: "TheLogin",
  props: ["loading"],
  data: () => {
    return {
      tab: 0,
      valid: false,
      userInfo: {} as any,
      passwordRules: [(v: any) => !!v || "Password is required"] as any[],
      emailRules: [
        (v: any) => !!v || "E-mail is required",
        (v: any) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ] as any[],
    };
  },
  methods: {
    resetForm() {
      this.userInfo = {};
    },
    verifyPasswords(): any {
      return (
        (this.userInfo.password &&
          this.userInfo.confirmPassword &&
          this.userInfo.password === this.userInfo.confirmPassword) ||
        "Passwords must match!"
      );
    },
  },
});
